var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab",style:({..._vm.iframeInfo.style, 'background-image': `url(${_vm.iframeInfo.src})`})},[_c('iframe',{attrs:{"width":"100%","height":"100%","scrolling":"no","frameborder":"0","src":_vm.newIframeURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }